var map = {
	"./images/404-image.svg": 399,
	"./images/404.png": 1934,
	"./images/404.svg": 1935,
	"./images/504.png": 400,
	"./images/AboutUs/10.png": 1289,
	"./images/AboutUs/AboutUs.png": 1693,
	"./images/AboutUs/CDN.svg": 1694,
	"./images/AboutUs/Colocation.svg": 1695,
	"./images/AboutUs/about-header.svg": 1696,
	"./images/AboutUs/analytics.svg": 1697,
	"./images/AboutUs/budget.svg": 1698,
	"./images/AboutUs/consulting.svg": 1699,
	"./images/AboutUs/container.svg": 1700,
	"./images/AboutUs/contract.svg": 1701,
	"./images/AboutUs/cost.svg": 1702,
	"./images/AboutUs/demo.svg": 1703,
	"./images/AboutUs/header.svg": 1704,
	"./images/AboutUs/history.png": 1705,
	"./images/AboutUs/license.svg": 1706,
	"./images/AboutUs/mission.png": 1707,
	"./images/AboutUs/missionicon.png": 1708,
	"./images/AboutUs/pop.svg": 1709,
	"./images/AboutUs/sazman.svg": 1710,
	"./images/AboutUs/security.svg": 1711,
	"./images/AboutUs/uptime.svg": 1712,
	"./images/ContactUs/1.png": 1726,
	"./images/ContactUs/2.png": 1727,
	"./images/ContactUs/3.png": 1728,
	"./images/ContactUs/4.png": 1729,
	"./images/ContactUs/5.png": 1730,
	"./images/ContactUs/Blog.svg": 1731,
	"./images/ContactUs/Blog.webp": 1732,
	"./images/ContactUs/ContactUs.png": 1733,
	"./images/ContactUs/ContactUsicon.png": 1734,
	"./images/ContactUs/Help.webp": 1735,
	"./images/ContactUs/Location.svg": 1736,
	"./images/ContactUs/Question.svg": 1737,
	"./images/ContactUs/Search.webp": 1738,
	"./images/ContactUs/Video.svg": 1739,
	"./images/ContactUs/facebook.svg": 1740,
	"./images/ContactUs/header.svg": 1574,
	"./images/ContactUs/instagram.svg": 1741,
	"./images/ContactUs/linkedin.svg": 1742,
	"./images/ContactUs/mail.svg": 1575,
	"./images/ContactUs/map-m.svg": 1743,
	"./images/ContactUs/map.svg": 1744,
	"./images/ContactUs/person.svg": 1576,
	"./images/ContactUs/phone.svg": 1430,
	"./images/ContactUs/pointer.svg": 1577,
	"./images/ContactUs/support.svg": 1578,
	"./images/ContactUs/telegram.svg": 1745,
	"./images/ContactUs/ticket.svg": 1579,
	"./images/ContactUs/twitter.svg": 1746,
	"./images/ContactUs/youtube.svg": 1747,
	"./images/MainSlider-ld/1.png": 1936,
	"./images/MainSlider-ld/2.png": 1937,
	"./images/MainSlider-ld/3.png": 1938,
	"./images/MainSlider-ld/4.png": 1939,
	"./images/MainSlider-ld/Main.png": 1940,
	"./images/MainSlider/1.png": 1941,
	"./images/MainSlider/2.png": 1942,
	"./images/MainSlider/3.png": 1943,
	"./images/MainSlider/4.png": 1944,
	"./images/MainSlider/Cloud-migration.jpg": 1945,
	"./images/MainSlider/Cloud-migration.webp": 1748,
	"./images/MainSlider/Main.png": 1946,
	"./images/MainSlider/Slider.png": 1947,
	"./images/MainSlider/XaaSSliderPlaformKubernetes.svg": 1948,
	"./images/MainSlider/XaaSSliderPlaformKubernetes1.svg": 1949,
	"./images/MainSlider/x-background.svg": 1950,
	"./images/MainSlider/xaas-logo.svg": 1951,
	"./images/ManagedService/Adobe.svg": 1162,
	"./images/ManagedService/Atlassia.svg": 1163,
	"./images/ManagedService/Big.svg": 1164,
	"./images/ManagedService/Bugzilla.svg": 1165,
	"./images/ManagedService/Cpanel.svg": 1166,
	"./images/ManagedService/Customers/Etebar-gary.png": 1094,
	"./images/ManagedService/Customers/Etebar.png": 1095,
	"./images/ManagedService/Customers/Mapna-gray.png": 1096,
	"./images/ManagedService/Customers/Sina- gray.png": 1097,
	"./images/ManagedService/Customers/Sina.png": 1098,
	"./images/ManagedService/Customers/afam-color.png": 1099,
	"./images/ManagedService/Customers/afam-gray.png": 1100,
	"./images/ManagedService/Customers/banner-eseminar.webp": 1101,
	"./images/ManagedService/Customers/banner-helal.webp": 1102,
	"./images/ManagedService/Customers/banner-kale.webp": 1103,
	"./images/ManagedService/Customers/banner-mapna.webp": 1104,
	"./images/ManagedService/Customers/bime.webp": 1105,
	"./images/ManagedService/Customers/eseminar-d.webp": 1106,
	"./images/ManagedService/Customers/eseminar.webp": 1107,
	"./images/ManagedService/Customers/helal-d.webp": 1108,
	"./images/ManagedService/Customers/helal.webp": 1109,
	"./images/ManagedService/Customers/industry.webp": 1110,
	"./images/ManagedService/Customers/it.webp": 1111,
	"./images/ManagedService/Customers/kale-d.webp": 1112,
	"./images/ManagedService/Customers/kale.webp": 1113,
	"./images/ManagedService/Customers/mapna-color.png": 1114,
	"./images/ManagedService/Customers/mapna-d.webp": 1115,
	"./images/ManagedService/Customers/mapna.webp": 1116,
	"./images/ManagedService/Customers/software.webp": 1117,
	"./images/ManagedService/Direct.svg": 1167,
	"./images/ManagedService/Django.svg": 1168,
	"./images/ManagedService/Elsstic.svg": 1169,
	"./images/ManagedService/Jira.svg": 1170,
	"./images/ManagedService/MariaDB.svg": 1171,
	"./images/ManagedService/Maskgroup.svg": 1133,
	"./images/ManagedService/Microsoft.svg": 1172,
	"./images/ManagedService/MongoDB.svg": 1173,
	"./images/ManagedService/Moodle.svg": 1174,
	"./images/ManagedService/MySQL.svg": 1175,
	"./images/ManagedService/Neo4j.svg": 1176,
	"./images/ManagedService/Opencart.svg": 1177,
	"./images/ManagedService/Plone.svg": 1178,
	"./images/ManagedService/PostgreSQL.svg": 1179,
	"./images/ManagedService/R1.svg": 914,
	"./images/ManagedService/R2.svg": 915,
	"./images/ManagedService/R3.svg": 916,
	"./images/ManagedService/R4.svg": 917,
	"./images/ManagedService/REDMINE.svg": 1180,
	"./images/ManagedService/Rocket.svg": 1181,
	"./images/ManagedService/Step1-m.svg": 1182,
	"./images/ManagedService/Step1.svg": 1183,
	"./images/ManagedService/Step2-m.svg": 1184,
	"./images/ManagedService/Step2.svg": 1185,
	"./images/ManagedService/Step3.svg": 1186,
	"./images/ManagedService/Wordmark.svg": 1187,
	"./images/ManagedService/agility.svg": 1188,
	"./images/ManagedService/avatar.svg": 1189,
	"./images/ManagedService/avatar2.svg": 1190,
	"./images/ManagedService/avatar3.svg": 1191,
	"./images/ManagedService/avatar4.svg": 1192,
	"./images/ManagedService/avatar5.svg": 1193,
	"./images/ManagedService/cancle.svg": 1194,
	"./images/ManagedService/centralized.svg": 1195,
	"./images/ManagedService/configuration.svg": 1196,
	"./images/ManagedService/devops.svg": 1197,
	"./images/ManagedService/enterprise.svg": 1198,
	"./images/ManagedService/exclusive.svg": 1199,
	"./images/ManagedService/focus.svg": 1200,
	"./images/ManagedService/hardening.svg": 1201,
	"./images/ManagedService/header.svg": 880,
	"./images/ManagedService/hero.svg": 1147,
	"./images/ManagedService/iRedMail.svg": 1202,
	"./images/ManagedService/joomla.svg": 1203,
	"./images/ManagedService/laravel.svg": 1204,
	"./images/ManagedService/managed_service.png": 1205,
	"./images/ManagedService/managedservices_catalogue.png": 1206,
	"./images/ManagedService/monitor.svg": 1207,
	"./images/ManagedService/monitoring.svg": 1208,
	"./images/ManagedService/osCommerce.svg": 1209,
	"./images/ManagedService/prometheus.svg": 1210,
	"./images/ManagedService/redis.svg": 1211,
	"./images/ManagedService/section-header.svg": 959,
	"./images/ManagedService/technical.svg": 1212,
	"./images/ManagedService/tick.svg": 918,
	"./images/ManagedService/tick1.svg": 1213,
	"./images/ManagedService/woocommerce.svg": 1214,
	"./images/Pack1/Back.png": 1952,
	"./images/Pack1/Back1.svg": 1953,
	"./images/Pack1/CloudServer.png": 1954,
	"./images/Pack1/CloudServer.svg": 1955,
	"./images/Pack1/Server1.svg": 1956,
	"./images/Pack1/Server2.svg": 1957,
	"./images/Pack1/Server3.svg": 1958,
	"./images/Pack1/server1.png": 1959,
	"./images/Pack1/server2.png": 1960,
	"./images/Pack1/server3.png": 1961,
	"./images/Pack1/svg/Back1.svg": 1962,
	"./images/Pack1/svg/CloudServer.svg": 1963,
	"./images/Pack1/svg/Server1.svg": 1964,
	"./images/Pack1/svg/Server2.svg": 1965,
	"./images/Pack1/svg/Server3.svg": 1966,
	"./images/Pack2/Back1.svg": 1967,
	"./images/Pack2/Back2.png": 1968,
	"./images/Pack2/Security1.svg": 1969,
	"./images/Pack2/Security2.svg": 1970,
	"./images/Pack2/security1.png": 1971,
	"./images/Pack2/security2.png": 1972,
	"./images/Pack2/svg/Back1.svg": 1973,
	"./images/Pack2/svg/Security1.svg": 1974,
	"./images/Pack2/svg/Security2.svg": 1975,
	"./images/Pack3/Back1.svg": 1976,
	"./images/Pack3/Back2.png": 1977,
	"./images/Pack3/Support.png": 1978,
	"./images/Pack3/Support.svg": 1979,
	"./images/Pack3/svg/Back1.svg": 1980,
	"./images/Pack3/svg/Support.svg": 1981,
	"./images/Pack4/P1.png": 1982,
	"./images/Pack4/P1.svg": 1983,
	"./images/Pack4/P12.png": 1984,
	"./images/Pack4/P2.png": 1985,
	"./images/Pack4/P2.svg": 1986,
	"./images/Pack4/P22.png": 1987,
	"./images/Pack4/P3.png": 1988,
	"./images/Pack4/P3.svg": 1989,
	"./images/Pack5/managed.png": 1990,
	"./images/Pack5/private.png": 1991,
	"./images/Pack5/server.png": 1992,
	"./images/Pack5/svg/managed.svg": 1993,
	"./images/Pack5/svg/private.svg": 1994,
	"./images/Pack5/svg/vpc.svg": 1995,
	"./images/Pack5/svg/vps.svg": 1996,
	"./images/Pack5/vpc.png": 1997,
	"./images/Slider/Back.png": 1998,
	"./images/Slider/Back.svg": 1999,
	"./images/Slider/CloudMain.png": 2000,
	"./images/Slider/CloudMain.svg": 2001,
	"./images/Slider/Group368.png": 2002,
	"./images/Slider/Group368.svg": 2003,
	"./images/Slider/Group383.svg": 2004,
	"./images/Slider/Part1.png": 2005,
	"./images/Slider/Part1.svg": 2006,
	"./images/Slider/Part2.png": 2007,
	"./images/Slider/Part2.svg": 2008,
	"./images/Slider/VPC.png": 2009,
	"./images/Slider/VPC.svg": 2010,
	"./images/Slider/cloud.png": 2011,
	"./images/Slider/cloud.svg": 2012,
	"./images/Slider/managed.png": 2013,
	"./images/Slider/managed.svg": 2014,
	"./images/Technicals/1.png": 2015,
	"./images/Technicals/11.png": 2016,
	"./images/Technicals/12.png": 2017,
	"./images/Technicals/2.png": 2018,
	"./images/Technicals/3.png": 2019,
	"./images/Technicals/4.png": 2020,
	"./images/Technicals/5.png": 2021,
	"./images/Technicals/6.png": 2022,
	"./images/Technicals/7.png": 2023,
	"./images/Technicals/8.png": 2024,
	"./images/Technicals/9.png": 2025,
	"./images/Technicals/Technicals10.png": 2026,
	"./images/VPC/1.png": 1017,
	"./images/VPC/10.png": 1018,
	"./images/VPC/11.png": 1019,
	"./images/VPC/2.png": 1020,
	"./images/VPC/3.png": 1021,
	"./images/VPC/4.png": 1022,
	"./images/VPC/5.png": 1023,
	"./images/VPC/6.png": 1024,
	"./images/VPC/7.png": 1025,
	"./images/VPC/Api.svg": 1026,
	"./images/VPC/CloudCanvas.svg": 1027,
	"./images/VPC/Customers/VPC-IT.jpg": 948,
	"./images/VPC/Customers/VPC-banks.jpg": 949,
	"./images/VPC/Customers/VPC-innovation.jpg": 950,
	"./images/VPC/Customers/VPC-insurance.jpg": 951,
	"./images/VPC/Firewall.svg": 1028,
	"./images/VPC/LoadBalancers.svg": 1029,
	"./images/VPC/NetworkTopology.svg": 1030,
	"./images/VPC/Step1-m.svg": 1031,
	"./images/VPC/Step1.svg": 1032,
	"./images/VPC/Step2-m.svg": 1011,
	"./images/VPC/Step2.svg": 1012,
	"./images/VPC/Step3.svg": 1013,
	"./images/VPC/VPC-Main.svg": 1033,
	"./images/VPC/VPC_Info.svg": 1034,
	"./images/VPC/VS.svg": 876,
	"./images/VPC/VirtualMachins.svg": 1035,
	"./images/VPC/Volumes.svg": 1036,
	"./images/VPC/backup.svg": 1037,
	"./images/VPC/blancing.svg": 1038,
	"./images/VPC/cancle.svg": 877,
	"./images/VPC/cloud-security.svg": 1039,
	"./images/VPC/cloudstorage.svg": 881,
	"./images/VPC/cover-video.jpg": 1040,
	"./images/VPC/dashboard.svg": 1041,
	"./images/VPC/datacenter.svg": 882,
	"./images/VPC/firewall.png": 1042,
	"./images/VPC/freeSupport.svg": 1043,
	"./images/VPC/header.svg": 913,
	"./images/VPC/hq.svg": 1044,
	"./images/VPC/image.svg": 1045,
	"./images/VPC/improve.svg": 1046,
	"./images/VPC/infrustructure.svg": 1047,
	"./images/VPC/ip.png": 1048,
	"./images/VPC/network.png": 1049,
	"./images/VPC/openstack.svg": 1050,
	"./images/VPC/platform.png": 1051,
	"./images/VPC/sazman.svg": 1052,
	"./images/VPC/sdn.svg": 1053,
	"./images/VPC/section-header.svg": 1054,
	"./images/VPC/security.svg": 1055,
	"./images/VPC/service-mgs.svg": 1056,
	"./images/VPC/signup.svg": 1057,
	"./images/VPC/sla.svg": 1058,
	"./images/VPC/snapshot.svg": 1059,
	"./images/VPC/store.svg": 1060,
	"./images/VPC/support.svg": 1061,
	"./images/VPC/tick.svg": 878,
	"./images/VPC/video.png": 1062,
	"./images/VPC/vpc-patform.png": 1063,
	"./images/VPC/vpc1.png": 1064,
	"./images/VPC/vpc10.png": 1065,
	"./images/VPC/vpc100.png": 1066,
	"./images/VPC/vpc11.png": 1067,
	"./images/VPC/vpc12.png": 1068,
	"./images/VPC/vpc13.png": 1069,
	"./images/VPC/vpc15.png": 1070,
	"./images/VPC/vpc17.png": 1071,
	"./images/VPC/vpc18.png": 1072,
	"./images/VPC/vpc19.png": 1073,
	"./images/VPC/vpc2.png": 1074,
	"./images/VPC/vpc3.png": 1075,
	"./images/VPC/vpc4.png": 1076,
	"./images/VPC/vpc5.png": 1077,
	"./images/VPC/vpc_platform.png": 1078,
	"./images/VPS/1minute.svg": 761,
	"./images/VPS/24.svg": 762,
	"./images/VPS/AlmaLinux.svg": 763,
	"./images/VPS/Customers/VPS-foods.jpg": 753,
	"./images/VPS/Customers/VPS-khandevane.jpg": 754,
	"./images/VPS/Customers/VPS-manufacturing-firms.jpg": 755,
	"./images/VPS/Customers/VPS-sunich.jpg": 756,
	"./images/VPS/Feature-3.svg": 764,
	"./images/VPS/Feature-4.svg": 765,
	"./images/VPS/Feature-5.svg": 766,
	"./images/VPS/Feature-8.svg": 767,
	"./images/VPS/Fedora.svg": 768,
	"./images/VPS/Google.svg": 769,
	"./images/VPS/HA.svg": 770,
	"./images/VPS/Isolation.svg": 771,
	"./images/VPS/P1.png": 772,
	"./images/VPS/P2.png": 773,
	"./images/VPS/P3.png": 774,
	"./images/VPS/P4.png": 775,
	"./images/VPS/P5.png": 776,
	"./images/VPS/PfSense.svg": 777,
	"./images/VPS/Rocky_Linux.svg": 778,
	"./images/VPS/Step1-m.svg": 779,
	"./images/VPS/Step1.svg": 780,
	"./images/VPS/Step2-m.svg": 781,
	"./images/VPS/Step2.svg": 782,
	"./images/VPS/Step3.svg": 783,
	"./images/VPS/Successful-Google-Cloud-Migration-1440x564_c 1.svg": 784,
	"./images/VPS/VPS_Info_.svg": 785,
	"./images/VPS/ads1.svg": 786,
	"./images/VPS/ads2.svg": 787,
	"./images/VPS/apache.svg": 788,
	"./images/VPS/architect.svg": 789,
	"./images/VPS/backup.svg": 790,
	"./images/VPS/calc.png": 791,
	"./images/VPS/centos.svg": 792,
	"./images/VPS/chooseOs.svg": 793,
	"./images/VPS/common-types.svg": 794,
	"./images/VPS/console.svg": 795,
	"./images/VPS/container.svg": 796,
	"./images/VPS/dashboard.svg": 797,
	"./images/VPS/ddos-c.svg": 798,
	"./images/VPS/ddos-d.svg": 799,
	"./images/VPS/ddos.svg": 800,
	"./images/VPS/debian.svg": 801,
	"./images/VPS/disaster.svg": 802,
	"./images/VPS/docker.svg": 803,
	"./images/VPS/everything.svg": 804,
	"./images/VPS/externalServer.svg": 805,
	"./images/VPS/firewall-new.svg": 806,
	"./images/VPS/firewall.png": 807,
	"./images/VPS/freeSupport.svg": 808,
	"./images/VPS/global.svg": 809,
	"./images/VPS/hq.svg": 810,
	"./images/VPS/iaas_catalogue.png": 811,
	"./images/VPS/ico.png": 812,
	"./images/VPS/image1.svg": 813,
	"./images/VPS/increase.svg": 814,
	"./images/VPS/infrustructure.svg": 815,
	"./images/VPS/ip.png": 816,
	"./images/VPS/iranServer.svg": 758,
	"./images/VPS/list-vps.svg": 817,
	"./images/VPS/mikrotik.svg": 818,
	"./images/VPS/mysql.svg": 819,
	"./images/VPS/nStep1-m.svg": 759,
	"./images/VPS/nStep1.svg": 760,
	"./images/VPS/nginx.svg": 820,
	"./images/VPS/nodejs.svg": 821,
	"./images/VPS/not-found-mobile.svg": 822,
	"./images/VPS/not-found.svg": 823,
	"./images/VPS/panel.svg": 824,
	"./images/VPS/pattern.png": 825,
	"./images/VPS/plans.svg": 826,
	"./images/VPS/plans/Maple.svg": 682,
	"./images/VPS/plans/Willow.svg": 683,
	"./images/VPS/plans/beech.svg": 684,
	"./images/VPS/plans/cedar.svg": 685,
	"./images/VPS/plans/pine.svg": 686,
	"./images/VPS/plans/poplar.svg": 687,
	"./images/VPS/platform.png": 827,
	"./images/VPS/platform2.png": 828,
	"./images/VPS/python.svg": 829,
	"./images/VPS/resource.svg": 830,
	"./images/VPS/service-mgs.svg": 831,
	"./images/VPS/service-vpc.svg": 832,
	"./images/VPS/service-vps.svg": 833,
	"./images/VPS/service.svg": 834,
	"./images/VPS/siem.svg": 835,
	"./images/VPS/sla.svg": 836,
	"./images/VPS/startup.svg": 837,
	"./images/VPS/support.svg": 838,
	"./images/VPS/test.svg": 839,
	"./images/VPS/top-ways.svg": 840,
	"./images/VPS/traffic-vps.svg": 841,
	"./images/VPS/ubuntu18.svg": 842,
	"./images/VPS/ubuntu22.svg": 843,
	"./images/VPS/uptime.svg": 844,
	"./images/VPS/video.png": 845,
	"./images/VPS/vps-header.svg": 752,
	"./images/VPS/vps-hourly.svg": 757,
	"./images/VPS/vps-platform.png": 846,
	"./images/VPS/vps1.png": 847,
	"./images/VPS/vps10.png": 848,
	"./images/VPS/vps2.png": 849,
	"./images/VPS/vps3.png": 850,
	"./images/VPS/vps4.png": 851,
	"./images/VPS/vps5.png": 852,
	"./images/VPS/vps6.png": 853,
	"./images/VPS/vps7.png": 854,
	"./images/VPS/vps8.png": 855,
	"./images/VPS/vps9.png": 856,
	"./images/VPS/vps_figure.png": 857,
	"./images/VPS/vps_icon.png": 858,
	"./images/VPS/vps_picture2.png": 859,
	"./images/VPS/vpspackage.png": 860,
	"./images/VPS/waf-c.svg": 861,
	"./images/VPS/waf-d.svg": 862,
	"./images/VPS/waf-icon-active.svg": 863,
	"./images/VPS/waf-icon.svg": 864,
	"./images/VPS/waf-vps.svg": 865,
	"./images/VPS/waf.svg": 866,
	"./images/VPS/windows.svg": 867,
	"./images/VPS/wordpress.svg": 868,
	"./images/Xicon.svg": 401,
	"./images/banners/123.svg": 2027,
	"./images/banners/Banner-Traffic-Campaign.png": 2028,
	"./images/banners/Banner.jpg": 2029,
	"./images/banners/Banner2.jpg": 2030,
	"./images/banners/Cloud-Database.webp": 2031,
	"./images/banners/Help.webp": 2032,
	"./images/banners/Network-Banner.webp": 2033,
	"./images/banners/Post-1.webp": 2034,
	"./images/banners/Post-2.webp": 2035,
	"./images/banners/Post-3.webp": 2036,
	"./images/banners/SLA.webp": 2037,
	"./images/banners/VPSvsVDS.webp": 2038,
	"./images/banners/banner6.svg": 2039,
	"./images/banners/nowruz-1403-banner.png": 2040,
	"./images/banners/server-response-time.webp": 2041,
	"./images/banners/vpc-service.svg": 2042,
	"./images/banners/yalda-report.png": 2043,
	"./images/cdn/CDN-Header.svg": 1215,
	"./images/cdn/Feature-1.svg": 1297,
	"./images/cdn/Feature-2.svg": 1298,
	"./images/cdn/Feature-3.svg": 1299,
	"./images/cdn/Feature-4.svg": 1300,
	"./images/cdn/Feature-5.svg": 1301,
	"./images/cdn/Feature-6.svg": 1302,
	"./images/cdn/Feature-7.svg": 1303,
	"./images/cdn/Feature-8.svg": 1304,
	"./images/cdn/IranMap.svg": 1137,
	"./images/cdn/Malwares_Attackers.svg": 1305,
	"./images/cdn/access.svg": 1306,
	"./images/cdn/atactks.svg": 1307,
	"./images/cdn/cms.svg": 1308,
	"./images/cdn/company-c.svg": 1309,
	"./images/cdn/company.svg": 1310,
	"./images/cdn/customer.svg": 1311,
	"./images/cdn/ddos-c.svg": 1312,
	"./images/cdn/ddos-d.svg": 1313,
	"./images/cdn/ddos.svg": 1314,
	"./images/cdn/ddosAtacks.svg": 1315,
	"./images/cdn/domain-c.svg": 1316,
	"./images/cdn/domain-d.svg": 1317,
	"./images/cdn/domain.svg": 1318,
	"./images/cdn/domainss.svg": 1319,
	"./images/cdn/earth.svg": 1145,
	"./images/cdn/geography.svg": 1320,
	"./images/cdn/no.svg": 871,
	"./images/cdn/price.svg": 1321,
	"./images/cdn/report-c.svg": 1322,
	"./images/cdn/report-d.svg": 1323,
	"./images/cdn/report.svg": 1324,
	"./images/cdn/scrubbing.svg": 1149,
	"./images/cdn/seo.svg": 1325,
	"./images/cdn/speed.svg": 1326,
	"./images/cdn/ssl.svg": 1327,
	"./images/cdn/startup-c.svg": 1328,
	"./images/cdn/startup.svg": 1329,
	"./images/cdn/store-c.svg": 1330,
	"./images/cdn/store.svg": 1331,
	"./images/cdn/tick.svg": 1332,
	"./images/cdn/uptime.svg": 1333,
	"./images/cdn/waf-c.svg": 1334,
	"./images/cdn/waf-d.svg": 1335,
	"./images/cdn/waf.svg": 1336,
	"./images/cdn/yes.svg": 872,
	"./images/cdn/zarb.svg": 1337,
	"./images/close.svg": 252,
	"./images/cloudGuard/AutomaticProtection.svg": 2044,
	"./images/cloudGuard/CreateCustomRules.svg": 2045,
	"./images/cloudGuard/DDosSection.svg": 2046,
	"./images/cloudGuard/PermanentAccess.svg": 2047,
	"./images/cloudGuard/ReducingDistance.svg": 2048,
	"./images/cloudGuard/SaveResources.svg": 2049,
	"./images/cloudGuard/WebFirewall.svg": 2050,
	"./images/cloudGuard/approach.svg": 2051,
	"./images/cloudGuard/appsAttacks.svg": 2052,
	"./images/cloudGuard/cdnService.svg": 2053,
	"./images/cloudGuard/cloudGuard.svg": 2054,
	"./images/cloudGuard/cloudguard_catalogue.png": 2055,
	"./images/cloudGuard/company-c.svg": 2056,
	"./images/cloudGuard/company.svg": 2057,
	"./images/cloudGuard/ddos-c.svg": 2058,
	"./images/cloudGuard/ddos-d.svg": 2059,
	"./images/cloudGuard/ddos.svg": 2060,
	"./images/cloudGuard/ddosProtection.svg": 2061,
	"./images/cloudGuard/disasterRecovery.svg": 2062,
	"./images/cloudGuard/firewall.svg": 2063,
	"./images/cloudGuard/firewallSetting-c.svg": 2064,
	"./images/cloudGuard/firewallSetting-d.svg": 2065,
	"./images/cloudGuard/firewallSetting.svg": 2066,
	"./images/cloudGuard/freeDNS.svg": 2067,
	"./images/cloudGuard/iam.svg": 2068,
	"./images/cloudGuard/infiniteDomain.svg": 2069,
	"./images/cloudGuard/ip.svg": 2070,
	"./images/cloudGuard/layer7attacks.svg": 2071,
	"./images/cloudGuard/limit-c.svg": 2072,
	"./images/cloudGuard/limit-d.svg": 2073,
	"./images/cloudGuard/limit.svg": 2074,
	"./images/cloudGuard/limitedAccess.svg": 2075,
	"./images/cloudGuard/massAttacks.svg": 2076,
	"./images/cloudGuard/protection.svg": 2077,
	"./images/cloudGuard/protocolAttacks.svg": 2078,
	"./images/cloudGuard/reduceCost.svg": 2079,
	"./images/cloudGuard/region.svg": 2080,
	"./images/cloudGuard/savings.svg": 2081,
	"./images/cloudGuard/scrubbing.svg": 2082,
	"./images/cloudGuard/security.svg": 2083,
	"./images/cloudGuard/seo.svg": 2084,
	"./images/cloudGuard/siem.svg": 2085,
	"./images/cloudGuard/startup-c.svg": 2086,
	"./images/cloudGuard/startup.svg": 2087,
	"./images/cloudGuard/store-c.svg": 2088,
	"./images/cloudGuard/store.svg": 2089,
	"./images/cloudGuard/uptime.svg": 2090,
	"./images/cloudGuard/url.svg": 2091,
	"./images/cloudGuard/userInfo.svg": 2092,
	"./images/cloudGuard/waf-c.svg": 2093,
	"./images/cloudGuard/waf-d.svg": 2094,
	"./images/cloudGuard/waf.svg": 2095,
	"./images/cloudMigration/customers/bonyad-shahid.svg": 1722,
	"./images/cloudMigration/customers/dataak.svg": 1723,
	"./images/cloudMigration/customers/eita.svg": 1724,
	"./images/cloudMigration/customers/helal-ahmar-iran.svg": 1725,
	"./images/colocation/architect.svg": 1908,
	"./images/colocation/firewall-new.svg": 1909,
	"./images/colocation/resource.svg": 1910,
	"./images/colocation/uptime.svg": 1911,
	"./images/customer/day_logo(1).png": 2096,
	"./images/customer/day_logo(1).svg": 2097,
	"./images/customer/farrahicarpet-logo.png": 2098,
	"./images/customer/farrahicarpet-logo.svg": 2099,
	"./images/customer/logo-.png": 2100,
	"./images/customer/logo-.svg": 2101,
	"./images/customer/logo-hamrahe-aval.png": 2102,
	"./images/customer/logo-hamrahe-aval.svg": 2103,
	"./images/customer/logo-kermanmotor-w.png": 2104,
	"./images/customer/logo-kermanmotor-w.svg": 2105,
	"./images/customer/snowa_logo.png": 2106,
	"./images/customer/snowa_logo.svg": 2107,
	"./images/customer/uniliver(2) 1.png": 2108,
	"./images/customer/uniliver(2) 1.svg": 2109,
	"./images/customers/10.png": 2110,
	"./images/customers/MobileViewLogo-min.png": 2111,
	"./images/customers/banner/HomePage-IT.webp": 1079,
	"./images/customers/banner/HomePage-agencies.webp": 1080,
	"./images/customers/banner/HomePage-banks.webp": 1081,
	"./images/customers/banner/HomePage-elearning.webp": 1082,
	"./images/customers/banner/HomePage-foods.webp": 1083,
	"./images/customers/banner/HomePage-industries.webp": 1084,
	"./images/customers/banner/HomePage-innovation.webp": 1085,
	"./images/customers/banner/HomePage-insurance.webp": 1086,
	"./images/customers/banner/HomePage-manufacturing-firms.webp": 1087,
	"./images/customers/banner/HomePage-media.webp": 1088,
	"./images/customers/banner/HomePage-universities.webp": 1089,
	"./images/customers/banner/Khandevane.png": 1090,
	"./images/customers/banner/sunich.png": 1091,
	"./images/customers/bime-day.png": 2112,
	"./images/customers/eseminar.png": 2113,
	"./images/customers/khandevane.png": 2114,
	"./images/customers/logo/Azad.png": 885,
	"./images/customers/logo/IRISA.png": 886,
	"./images/customers/logo/Mapna.png": 887,
	"./images/customers/logo/Samseir.png": 888,
	"./images/customers/logo/day-insurance-gary.png": 889,
	"./images/customers/logo/day-insurance.png": 890,
	"./images/customers/logo/dey.png": 891,
	"./images/customers/logo/diginext-gray.png": 892,
	"./images/customers/logo/diginext.png": 893,
	"./images/customers/logo/eastcool-gray.png": 894,
	"./images/customers/logo/eastcool-rgb.png": 895,
	"./images/customers/logo/esiminar.png": 896,
	"./images/customers/logo/irisa-gray.png": 897,
	"./images/customers/logo/irisa.png": 898,
	"./images/customers/logo/istcoll.png": 899,
	"./images/customers/logo/khandevane-gray.png": 900,
	"./images/customers/logo/khandevane-rgb.png": 901,
	"./images/customers/logo/khandevaneh.png": 902,
	"./images/customers/logo/pars.png": 903,
	"./images/customers/logo/pegah.png": 904,
	"./images/customers/logo/persis-foods-gray.png": 905,
	"./images/customers/logo/persis-foods-rgb.png": 906,
	"./images/customers/logo/refah.png": 907,
	"./images/customers/logo/shahr-financial-group-gray.png": 908,
	"./images/customers/logo/shahr-financial-group.png": 909,
	"./images/customers/logo/shahr.png": 910,
	"./images/customers/logo/sunich-gray.png": 911,
	"./images/customers/logo/sunich-rgb.png": 912,
	"./images/customers/meydon.png": 2115,
	"./images/customers/parskh.png": 2116,
	"./images/customers/parsonline.png": 2117,
	"./images/customers/refah.png": 2118,
	"./images/customers/shahr.png": 2119,
	"./images/customers/t1.png": 2120,
	"./images/ddosProtection/1.svg": 987,
	"./images/ddosProtection/2.svg": 988,
	"./images/ddosProtection/3.svg": 989,
	"./images/ddosProtection/CloudGuard-Service.svg": 990,
	"./images/ddosProtection/DNS.svg": 991,
	"./images/ddosProtection/ManagedService-Service.svg": 992,
	"./images/ddosProtection/VPC-Service.svg": 993,
	"./images/ddosProtection/VPS-Service.svg": 994,
	"./images/ddosProtection/ddos-d.svg": 995,
	"./images/ddosProtection/ddos-image.svg": 924,
	"./images/ddosProtection/ddos.svg": 996,
	"./images/ddosProtection/devops.svg": 997,
	"./images/ddosProtection/exclusive.svg": 998,
	"./images/ddosProtection/firewall-ability.1bb527e 1.svg": 999,
	"./images/ddosProtection/firewall-setting.cc1ac98 1.svg": 1000,
	"./images/ddosProtection/focus.svg": 1001,
	"./images/ddosProtection/hardening.svg": 1002,
	"./images/ddosProtection/limitation.cb39432 1.svg": 1003,
	"./images/ddosProtection/monitoring.svg": 1004,
	"./images/ddosProtection/technical.svg": 1005,
	"./images/ddosProtection/traffic-vps.aa00c67 1.svg": 1006,
	"./images/ddosProtection/waf-d.svg": 1007,
	"./images/ddosProtection/waf-icon-active.svg": 1008,
	"./images/ddosProtection/waf-icon.svg": 1009,
	"./images/ddosProtection/waf.svg": 1010,
	"./images/dedicateServer/backup.svg": 2121,
	"./images/dedicateServer/buy.svg": 2122,
	"./images/dedicateServer/customized.svg": 2123,
	"./images/dedicateServer/dedicate-server.svg": 2124,
	"./images/dedicateServer/internal-cloud.svg": 2125,
	"./images/dedicateServer/internal.svg": 2126,
	"./images/dedicateServer/performance.svg": 2127,
	"./images/dedicateServer/resource.svg": 2128,
	"./images/dedicateServer/secure.svg": 2129,
	"./images/dedicateServer/web-hosting.svg": 2130,
	"./images/dedicatedServer/firewall-new.svg": 1749,
	"./images/dedicatedServer/image1.svg": 1750,
	"./images/dedicatedServer/resource.svg": 1751,
	"./images/dedicatedServer/uptime.svg": 1752,
	"./images/devops/apps/Ansible.svg": 1753,
	"./images/devops/apps/Apache-Mesos.svg": 1754,
	"./images/devops/apps/Apache.svg": 1755,
	"./images/devops/apps/Cassandra.svg": 1756,
	"./images/devops/apps/Ceph.svg": 1757,
	"./images/devops/apps/Chef.svg": 1758,
	"./images/devops/apps/Datadog.svg": 1759,
	"./images/devops/apps/Docker-Swarm.svg": 1760,
	"./images/devops/apps/Elastic-Stack.svg": 1761,
	"./images/devops/apps/GitLab.svg": 1762,
	"./images/devops/apps/GlusterFS.svg": 1763,
	"./images/devops/apps/Grafana.svg": 1764,
	"./images/devops/apps/IIS.svg": 1765,
	"./images/devops/apps/Jenkins.svg": 1766,
	"./images/devops/apps/Kubernetes.svg": 1767,
	"./images/devops/apps/Lighttpd.svg": 1768,
	"./images/devops/apps/LiteSpeed.svg": 1769,
	"./images/devops/apps/MariaDB.svg": 1770,
	"./images/devops/apps/MinIO.svg": 1771,
	"./images/devops/apps/MongoDB.svg": 1772,
	"./images/devops/apps/MySQL.svg": 1773,
	"./images/devops/apps/NextCloud.svg": 1774,
	"./images/devops/apps/Nginx.svg": 1775,
	"./images/devops/apps/OpenShift.svg": 1776,
	"./images/devops/apps/PostgreSQL.svg": 1777,
	"./images/devops/apps/Prometheus.svg": 1778,
	"./images/devops/apps/Puppet.svg": 1779,
	"./images/devops/apps/Redis.svg": 1780,
	"./images/devops/apps/Splunk.svg": 1781,
	"./images/devops/apps/Terraform.svg": 1782,
	"./images/devops/apps/Tomcat.svg": 1783,
	"./images/devops/apps/Zabbix.svg": 1784,
	"./images/devops/customers/Azad-Uni.webp": 1275,
	"./images/devops/customers/Bank-Sina.webp": 1276,
	"./images/devops/customers/Iraninan-Poshesh.webp": 1277,
	"./images/devops/customers/azad-university.svg": 1278,
	"./images/devops/customers/helal-ahmar.svg": 1279,
	"./images/devops/customers/helal-ahmar.webp": 1280,
	"./images/devops/customers/iranian-insurance.svg": 1281,
	"./images/devops/customers/sina-bank.svg": 1282,
	"./images/devops/icons/Feature-3.svg": 1118,
	"./images/devops/icons/Feature-6.svg": 1119,
	"./images/devops/icons/agility.svg": 1120,
	"./images/devops/icons/centralized.svg": 1121,
	"./images/devops/icons/configuration.svg": 1122,
	"./images/devops/icons/devops.svg": 1123,
	"./images/devops/icons/enterprise.svg": 1124,
	"./images/devops/icons/focus.svg": 1125,
	"./images/devops/icons/hardening.svg": 1126,
	"./images/devops/icons/hosting.svg": 1127,
	"./images/devops/icons/monitor.svg": 1128,
	"./images/devops/icons/monitoring.svg": 1129,
	"./images/devops/icons/startupLoad.svg": 1130,
	"./images/devops/icons/technical.svg": 1131,
	"./images/devops/icons/test.svg": 1132,
	"./images/devops/images/section-header.svg": 1144,
	"./images/devops/images/storage.svg": 1338,
	"./images/dns/DNS-Header.svg": 1267,
	"./images/dns/Feature-1.svg": 1785,
	"./images/dns/Feature-2.svg": 1786,
	"./images/dns/Feature-3.svg": 1787,
	"./images/dns/Feature-4.svg": 1788,
	"./images/dns/anyCast.svg": 1789,
	"./images/dns/dnsPanel.svg": 1790,
	"./images/dns/noLimit.svg": 1791,
	"./images/dns/responseDelay.svg": 1792,
	"./images/dns/unlimitedDomain.svg": 1793,
	"./images/dnsproxy/logos/AMD.svg": 1431,
	"./images/dnsproxy/logos/CentOs.svg": 1432,
	"./images/dnsproxy/logos/DockerHub.svg": 1433,
	"./images/dnsproxy/logos/ElasticStack.svg": 1434,
	"./images/dnsproxy/logos/FedoraProject.svg": 1435,
	"./images/dnsproxy/logos/GitHub.svg": 1436,
	"./images/dnsproxy/logos/GitLab.svg": 1437,
	"./images/dnsproxy/logos/Golang.svg": 1438,
	"./images/dnsproxy/logos/Grafana.svg": 1439,
	"./images/dnsproxy/logos/Intel.svg": 1440,
	"./images/dnsproxy/logos/Jenkins.svg": 1441,
	"./images/dnsproxy/logos/Kubernetes.svg": 1442,
	"./images/dnsproxy/logos/Microsoft.svg": 1443,
	"./images/dnsproxy/logos/NVIDIADeveloper.svg": 1444,
	"./images/dnsproxy/logos/Node.js.svg": 1445,
	"./images/dnsproxy/logos/Oracle.svg": 1446,
	"./images/dnsproxy/logos/Prometheus.svg": 1447,
	"./images/dnsproxy/logos/Python.svg": 1448,
	"./images/dnsproxy/logos/RedHat.svg": 1449,
	"./images/dnsproxy/logos/RockyLinux.svg": 1450,
	"./images/dnsproxy/logos/Splunk.svg": 1451,
	"./images/dnsproxy/logos/TeamViewer.svg": 1452,
	"./images/dnsproxy/logos/TensorFlow.svg": 1453,
	"./images/dnsproxy/logos/Ubuntu.svg": 1454,
	"./images/dnsproxy/logos/VMware.svg": 1455,
	"./images/dnsproxy/logos/mongodb.svg": 1456,
	"./images/dnsproxy/logos/virtualbox.svg": 1457,
	"./images/enterprise-services/VPC-Main.svg": 1794,
	"./images/enterprise-services/benefit.svg": 1795,
	"./images/enterprise-services/header.svg": 1796,
	"./images/europeVps/24.svg": 1458,
	"./images/europeVps/CloudGuard-Service.svg": 1459,
	"./images/europeVps/DNS.svg": 1460,
	"./images/europeVps/ManagedService-Service.svg": 1461,
	"./images/europeVps/VPC-Service.svg": 1462,
	"./images/europeVps/backup.svg": 1463,
	"./images/europeVps/chooseOs.svg": 1464,
	"./images/europeVps/console.svg": 1465,
	"./images/europeVps/dashboard.svg": 1466,
	"./images/europeVps/ddos-d.svg": 1467,
	"./images/europeVps/ddos.svg": 1468,
	"./images/europeVps/disaster.svg": 1469,
	"./images/europeVps/freeSupport.svg": 1470,
	"./images/europeVps/global.svg": 1471,
	"./images/europeVps/hq.svg": 1472,
	"./images/europeVps/infrustructure.svg": 1473,
	"./images/europeVps/list-vps.f735948 1.svg": 1474,
	"./images/europeVps/service.svg": 1475,
	"./images/europeVps/startup.svg": 1476,
	"./images/europeVps/traffic-vps.aa00c67 1.svg": 1477,
	"./images/europeVps/waf-d.svg": 1478,
	"./images/europeVps/waf-icon-active copy.svg": 1479,
	"./images/europeVps/waf-icon-active.svg": 1480,
	"./images/europeVps/waf-icon.svg": 1481,
	"./images/europeVps/waf-vps.fcecd73 1.svg": 1482,
	"./images/europeVps/waf.svg": 1483,
	"./images/events/sari-event-mobile.webp": 1797,
	"./images/events/sari-event.webp": 1798,
	"./images/footer.png": 443,
	"./images/footer/anjoman.svg": 444,
	"./images/footer/daneshbonyan.svg": 445,
	"./images/footer/enamad.svg": 446,
	"./images/footer/fab.svg": 447,
	"./images/footer/instagram.svg": 448,
	"./images/footer/linkedin.svg": 449,
	"./images/footer/location.svg": 450,
	"./images/footer/nezamsenfi.svg": 451,
	"./images/footer/occc.svg": 452,
	"./images/footer/phone.svg": 453,
	"./images/footer/riasatjomhoori.svg": 454,
	"./images/footer/telegram.svg": 455,
	"./images/footer/twitter.svg": 456,
	"./images/footer/youtube.svg": 457,
	"./images/form.svg": 402,
	"./images/header-cropped.svg": 2131,
	"./images/header/vpc-icon.webp": 1580,
	"./images/home/Content distribution-c.svg": 2132,
	"./images/home/Managedservices-c.svg": 2133,
	"./images/home/Platform-c.svg": 2134,
	"./images/home/Server-c.svg": 2135,
	"./images/home/TrafficCampaign.svg": 2136,
	"./images/home/contentdistribution.svg": 2137,
	"./images/home/contentdistribution_d.svg": 2138,
	"./images/home/data center-c.svg": 2139,
	"./images/home/general_catalogue.png": 2140,
	"./images/home/live.svg": 2141,
	"./images/home/manageServices.svg": 2142,
	"./images/home/manageServices_d.svg": 2143,
	"./images/home/nowruz-1403-logo.svg": 2144,
	"./images/home/nowruz.png": 2145,
	"./images/home/paas.svg": 2146,
	"./images/home/paas_d.svg": 2147,
	"./images/home/security-c.svg": 2148,
	"./images/home/security.svg": 2149,
	"./images/home/security_d.svg": 2150,
	"./images/home/shop.svg": 2151,
	"./images/home/vpc.svg": 2152,
	"./images/home/vpc_d.svg": 2153,
	"./images/home/vps.svg": 2154,
	"./images/home/vps_d.svg": 2155,
	"./images/home/yalda-m.svg": 2156,
	"./images/home/yalda.png": 2157,
	"./images/hourlyVps/1minute.svg": 1484,
	"./images/hourlyVps/24.svg": 1485,
	"./images/hourlyVps/CloudGuard-Service.svg": 1486,
	"./images/hourlyVps/DNS.svg": 1487,
	"./images/hourlyVps/ManagedService-Service.svg": 1488,
	"./images/hourlyVps/VPC-Service.svg": 1489,
	"./images/hourlyVps/chooseOs.svg": 1490,
	"./images/hourlyVps/console.svg": 1491,
	"./images/hourlyVps/dashboard.svg": 1492,
	"./images/hourlyVps/ddos-d.svg": 1493,
	"./images/hourlyVps/ddos.svg": 1494,
	"./images/hourlyVps/disaster.svg": 1495,
	"./images/hourlyVps/firewall-new.svg": 1496,
	"./images/hourlyVps/freeSupport.svg": 1497,
	"./images/hourlyVps/global.svg": 1498,
	"./images/hourlyVps/hq.svg": 1499,
	"./images/hourlyVps/increase.svg": 1500,
	"./images/hourlyVps/infrustructure.svg": 1501,
	"./images/hourlyVps/list-vps.f735948 1.svg": 1502,
	"./images/hourlyVps/sla.svg": 1503,
	"./images/hourlyVps/startup.svg": 1504,
	"./images/hourlyVps/support.svg": 1505,
	"./images/hourlyVps/test.svg": 1506,
	"./images/hourlyVps/traffic-vps.aa00c67 1.svg": 1507,
	"./images/hourlyVps/uptime.svg": 1508,
	"./images/hourlyVps/virtualOrganization.svg": 1509,
	"./images/hourlyVps/waf-d.svg": 1510,
	"./images/hourlyVps/waf-icon-active.svg": 1511,
	"./images/hourlyVps/waf-icon.svg": 1512,
	"./images/hourlyVps/waf-vps.fcecd73 1.svg": 1513,
	"./images/hourlyVps/waf.svg": 1514,
	"./images/icons/1.png": 689,
	"./images/icons/2.png": 690,
	"./images/icons/3.png": 691,
	"./images/icons/4.png": 692,
	"./images/icons/5.png": 693,
	"./images/icons/5.svg": 694,
	"./images/icons/6.png": 695,
	"./images/icons/7.png": 696,
	"./images/icons/CloudGuard-Service.svg": 697,
	"./images/icons/DNS.svg": 698,
	"./images/icons/GoDown.png": 699,
	"./images/icons/GoDown.svg": 700,
	"./images/icons/GoTop.png": 701,
	"./images/icons/GoTop.svg": 702,
	"./images/icons/Group 420.png": 703,
	"./images/icons/Group 420.svg": 704,
	"./images/icons/Group 78.png": 705,
	"./images/icons/Group 78.svg": 706,
	"./images/icons/Group.png": 707,
	"./images/icons/Insta.png": 708,
	"./images/icons/ManagedService-Service.svg": 709,
	"./images/icons/VPC-Service.svg": 710,
	"./images/icons/VPS-Service.svg": 711,
	"./images/icons/anjoman_s.png": 712,
	"./images/icons/anjoman_s.svg": 713,
	"./images/icons/bar.svg": 714,
	"./images/icons/cloud-dns.svg": 715,
	"./images/icons/contact.png": 716,
	"./images/icons/contact.svg": 688,
	"./images/icons/daneshbonyan.png": 717,
	"./images/icons/daneshbonyan.svg": 718,
	"./images/icons/ddos.svg": 719,
	"./images/icons/discount.png": 720,
	"./images/icons/discount.svg": 721,
	"./images/icons/enamad-logo.png": 722,
	"./images/icons/enamad-logo.svg": 723,
	"./images/icons/facebook.png": 724,
	"./images/icons/facebook.svg": 725,
	"./images/icons/github.png": 726,
	"./images/icons/github.svg": 727,
	"./images/icons/insta.svg": 728,
	"./images/icons/instagram.png": 729,
	"./images/icons/instagram.svg": 730,
	"./images/icons/linked.svg": 731,
	"./images/icons/linkedin.png": 732,
	"./images/icons/linkedin.svg": 733,
	"./images/icons/new/xaas-instagram.png": 734,
	"./images/icons/new/xaas-linkedin.png": 735,
	"./images/icons/new/xaas-telegram.png": 736,
	"./images/icons/new/xaas-twitter.png": 737,
	"./images/icons/new/xaas-youtube.png": 738,
	"./images/icons/nezam-senfi.png": 739,
	"./images/icons/nezam-senfi.svg": 740,
	"./images/icons/quote.png": 679,
	"./images/icons/showMore.svg": 674,
	"./images/icons/tweet.svg": 741,
	"./images/icons/tweter.png": 742,
	"./images/icons/twitter.png": 743,
	"./images/icons/twitter.svg": 744,
	"./images/icons/vps_icon2.png": 745,
	"./images/icons/xaas-fab.png": 746,
	"./images/icons/xaas-fab.svg": 747,
	"./images/icons/xaas-occc.png": 748,
	"./images/icons/xaas-occc.svg": 749,
	"./images/icons/xaas-riasat-jomhoori.png": 750,
	"./images/icons/xaas-riasat-jomhoori.svg": 751,
	"./images/img1.png": 1799,
	"./images/img2.png": 2158,
	"./images/isolatedCloud/CloudGuard-Service.svg": 925,
	"./images/isolatedCloud/Feature-1.svg": 926,
	"./images/isolatedCloud/Feature-2.svg": 927,
	"./images/isolatedCloud/Feature-3.svg": 928,
	"./images/isolatedCloud/Feature-4.svg": 929,
	"./images/isolatedCloud/Feature-5.svg": 930,
	"./images/isolatedCloud/Feature-6.svg": 931,
	"./images/isolatedCloud/Feature-7.svg": 932,
	"./images/isolatedCloud/Feature-8.svg": 933,
	"./images/isolatedCloud/ManagedService-Service.svg": 934,
	"./images/isolatedCloud/VPC-Service.svg": 935,
	"./images/isolatedCloud/VPS-Service.svg": 936,
	"./images/isolatedCloud/advancedSecurity.svg": 937,
	"./images/isolatedCloud/backup.svg": 938,
	"./images/isolatedCloud/disaster.svg": 939,
	"./images/isolatedCloud/easyBuy.svg": 940,
	"./images/isolatedCloud/easyUse.svg": 941,
	"./images/isolatedCloud/hunezarat.svg": 922,
	"./images/isolatedCloud/liveMigration.svg": 942,
	"./images/isolatedCloud/reliability.svg": 943,
	"./images/isolatedCloud/service.svg": 944,
	"./images/isolatedCloud/startup.svg": 945,
	"./images/isolatedCloud/test.svg": 946,
	"./images/isolatedCloud/virtualOrganization.svg": 947,
	"./images/landing/1045479.svg": 2159,
	"./images/landing/2906274.svg": 2160,
	"./images/landing/860238.svg": 2161,
	"./images/landing/860239.svg": 2162,
	"./images/landing/Group 12.svg": 2163,
	"./images/landing/Group 13.svg": 2164,
	"./images/landing/Group 14.svg": 2165,
	"./images/landing/Group 15.svg": 2166,
	"./images/landing/Group 16.webp": 2167,
	"./images/landing/Group 17.svg": 2168,
	"./images/landing/Group.svg": 2169,
	"./images/landing/Xaas.svg": 2170,
	"./images/landing/abr.svg": 2171,
	"./images/landing/avatar.svg": 2172,
	"./images/landing/background.png": 2173,
	"./images/landing/button.svg": 2174,
	"./images/landing/chamedoon.png": 2175,
	"./images/landing/cloud.svg": 2176,
	"./images/landing/data-analysis.svg": 2177,
	"./images/landing/landing.jpg": 2178,
	"./images/landing/project-analysis.svg": 2179,
	"./images/landing/shield.svg": 2180,
	"./images/landing/small-screen-arrow.svg": 2181,
	"./images/landing/web-security.svg": 2182,
	"./images/linuxVps/1minute.svg": 1581,
	"./images/linuxVps/24.svg": 1582,
	"./images/linuxVps/CloudGuard-Service.svg": 1583,
	"./images/linuxVps/DNS.svg": 1584,
	"./images/linuxVps/ManagedService-Service.svg": 1585,
	"./images/linuxVps/VPC-Service.svg": 1586,
	"./images/linuxVps/chooseOs.svg": 1587,
	"./images/linuxVps/console.svg": 1588,
	"./images/linuxVps/dashboard.svg": 1589,
	"./images/linuxVps/ddos-d.svg": 1590,
	"./images/linuxVps/ddos.svg": 1591,
	"./images/linuxVps/firewall-new.svg": 1592,
	"./images/linuxVps/freeSupport.svg": 1593,
	"./images/linuxVps/global.svg": 1594,
	"./images/linuxVps/hq.svg": 1595,
	"./images/linuxVps/increase.svg": 1596,
	"./images/linuxVps/infrustructure.svg": 1597,
	"./images/linuxVps/list-vps.f735948 1.svg": 1598,
	"./images/linuxVps/sla.svg": 1599,
	"./images/linuxVps/support.svg": 1600,
	"./images/linuxVps/traffic-vps.aa00c67 1.svg": 1601,
	"./images/linuxVps/uptime.svg": 1602,
	"./images/linuxVps/waf-d.svg": 1603,
	"./images/linuxVps/waf-icon-active.svg": 1604,
	"./images/linuxVps/waf-icon.svg": 1605,
	"./images/linuxVps/waf-vps.fcecd73 1.svg": 1606,
	"./images/linuxVps/waf.svg": 1607,
	"./images/logo-w.svg": 2183,
	"./images/logo.svg": 1608,
	"./images/menu-icons/addons.svg": 404,
	"./images/menu-icons/blog.svg": 405,
	"./images/menu-icons/calc.svg": 406,
	"./images/menu-icons/cdn.svg": 407,
	"./images/menu-icons/cdn24.svg": 408,
	"./images/menu-icons/cloud-network.svg": 409,
	"./images/menu-icons/combination-cloud.svg": 410,
	"./images/menu-icons/company-size.svg": 411,
	"./images/menu-icons/coprate.svg": 412,
	"./images/menu-icons/ddos.svg": 413,
	"./images/menu-icons/digital-tahavol.svg": 414,
	"./images/menu-icons/faq.svg": 415,
	"./images/menu-icons/free.svg": 416,
	"./images/menu-icons/how-to-start.svg": 417,
	"./images/menu-icons/in-xaas.svg": 418,
	"./images/menu-icons/industry.svg": 419,
	"./images/menu-icons/infra.svg": 420,
	"./images/menu-icons/left15.svg": 421,
	"./images/menu-icons/left7.svg": 422,
	"./images/menu-icons/main3.svg": 423,
	"./images/menu-icons/manage.svg": 424,
	"./images/menu-icons/manage24.svg": 425,
	"./images/menu-icons/migrate.svg": 426,
	"./images/menu-icons/organ-docs.svg": 427,
	"./images/menu-icons/organ-security.svg": 428,
	"./images/menu-icons/organ-solutions.svg": 429,
	"./images/menu-icons/organization.svg": 430,
	"./images/menu-icons/paas.svg": 431,
	"./images/menu-icons/prices.svg": 432,
	"./images/menu-icons/private-cloud.svg": 433,
	"./images/menu-icons/security.svg": 434,
	"./images/menu-icons/service-help.svg": 435,
	"./images/menu-icons/sla.svg": 436,
	"./images/menu-icons/special.svg": 437,
	"./images/menu-icons/storage.svg": 438,
	"./images/menu-icons/tech-services-for-organs.svg": 439,
	"./images/menu-icons/vpc.svg": 440,
	"./images/menu-icons/vps.svg": 441,
	"./images/new_customers/HiMart.png": 2184,
	"./images/new_customers/amirkabir.png": 2185,
	"./images/new_customers/azad.png": 2186,
	"./images/new_customers/bankrefah.png": 2187,
	"./images/new_customers/bankshahr.png": 2188,
	"./images/new_customers/barkat.png": 2189,
	"./images/new_customers/bidbarg.png": 2190,
	"./images/new_customers/bime-dey.png": 2191,
	"./images/new_customers/digikala.png": 2192,
	"./images/new_customers/eastcool.png": 2193,
	"./images/new_customers/elmosanat.png": 2194,
	"./images/new_customers/freezone.png": 2195,
	"./images/new_customers/irisaco.png": 2196,
	"./images/new_customers/jameazad.png": 2197,
	"./images/new_customers/javid.png": 2198,
	"./images/new_customers/khandevane.png": 2199,
	"./images/new_customers/madiran.png": 2200,
	"./images/new_customers/mahran.png": 2201,
	"./images/new_customers/mashal.png": 2202,
	"./images/new_customers/meydon.png": 2203,
	"./images/new_customers/mofid.png": 2204,
	"./images/new_customers/netbarg.png": 2205,
	"./images/new_customers/parskhazar.png": 2206,
	"./images/new_customers/parsonline.png": 2207,
	"./images/new_customers/pegah.png": 2208,
	"./images/new_customers/pejoheshgah.png": 2209,
	"./images/new_customers/samseir.png": 2210,
	"./images/new_customers/tanzim.png": 2211,
	"./images/organizationalSolution/24.svg": 1339,
	"./images/organizationalSolution/CDN-Header.svg": 923,
	"./images/organizationalSolution/CloudGuard-Service.svg": 1340,
	"./images/organizationalSolution/DNS.svg": 1341,
	"./images/organizationalSolution/HA.svg": 1342,
	"./images/organizationalSolution/Isolation.svg": 1343,
	"./images/organizationalSolution/ManagedService-Service.svg": 1344,
	"./images/organizationalSolution/VPC-Main.svg": 1283,
	"./images/organizationalSolution/VPC-Service.svg": 1345,
	"./images/organizationalSolution/architect.svg": 1346,
	"./images/organizationalSolution/backup.svg": 1347,
	"./images/organizationalSolution/blancing.svg": 1348,
	"./images/organizationalSolution/chooseOs.svg": 1349,
	"./images/organizationalSolution/container.svg": 1350,
	"./images/organizationalSolution/dashboard.svg": 1351,
	"./images/organizationalSolution/ddos-image.svg": 1284,
	"./images/organizationalSolution/devops.svg": 1352,
	"./images/organizationalSolution/freeSupport.svg": 1353,
	"./images/organizationalSolution/global.svg": 1354,
	"./images/organizationalSolution/header.svg": 1355,
	"./images/organizationalSolution/improve.svg": 1356,
	"./images/organizationalSolution/increase.svg": 1357,
	"./images/organizationalSolution/kuber.svg": 1358,
	"./images/organizationalSolution/migration.svg": 1359,
	"./images/organizationalSolution/monitoring.svg": 1360,
	"./images/organizationalSolution/openstack.svg": 1361,
	"./images/organizationalSolution/panel.svg": 1362,
	"./images/organizationalSolution/plans.svg": 1363,
	"./images/organizationalSolution/resource.svg": 1364,
	"./images/organizationalSolution/service.svg": 1365,
	"./images/organizationalSolution/sla.svg": 1366,
	"./images/organizationalSolution/snapshot.svg": 1367,
	"./images/organizationalSolution/support.svg": 1368,
	"./images/paas/1.png": 1800,
	"./images/paas/1.svg": 1801,
	"./images/paas/10.svg": 1802,
	"./images/paas/2.png": 1803,
	"./images/paas/2.svg": 1804,
	"./images/paas/3.png": 1805,
	"./images/paas/3.svg": 1806,
	"./images/paas/4.png": 1807,
	"./images/paas/4.svg": 1808,
	"./images/paas/5.svg": 1609,
	"./images/paas/6.svg": 1610,
	"./images/paas/7.svg": 1611,
	"./images/paas/8.svg": 1809,
	"./images/paas/9.svg": 1810,
	"./images/paas/api.svg": 1811,
	"./images/paas/dashboard.svg": 1812,
	"./images/paas/esteghrar.svg": 1813,
	"./images/paas/event.svg": 1814,
	"./images/paas/logo.svg": 1612,
	"./images/paas/monitoring.svg": 1815,
	"./images/paas/scale.svg": 1816,
	"./images/paas/store.svg": 1817,
	"./images/paas/support.svg": 1818,
	"./images/paas/tozie.svg": 1819,
	"./images/pam/auth2.svg": 1515,
	"./images/pam/browser.svg": 1516,
	"./images/pam/control.svg": 1517,
	"./images/pam/device.svg": 1518,
	"./images/pam/health.svg": 1519,
	"./images/pam/impersonate.svg": 1520,
	"./images/pam/leak.svg": 1521,
	"./images/pam/limit-access.svg": 1522,
	"./images/pam/log.svg": 1523,
	"./images/pam/manage-acc.svg": 1524,
	"./images/pam/manage-security.svg": 1525,
	"./images/pam/manage-user.svg": 1526,
	"./images/pam/manage.svg": 1527,
	"./images/pam/mfa.svg": 1528,
	"./images/pam/otp.svg": 1529,
	"./images/pam/pam.svg": 1530,
	"./images/pam/prevent.svg": 1531,
	"./images/pam/protocol.svg": 1532,
	"./images/pam/record.svg": 1533,
	"./images/pam/reports.svg": 1534,
	"./images/pam/users.svg": 1535,
	"./images/pam/web.svg": 1536,
	"./images/pomegrante.svg": 2212,
	"./images/rebranding/catalogue/managed-services-catalogue.webp": 2213,
	"./images/rebranding/catalogue/solutions-catalogue.webp": 1613,
	"./images/rebranding/contact/account.svg": 2214,
	"./images/rebranding/contact/contract.svg": 2215,
	"./images/rebranding/contact/products.svg": 2216,
	"./images/rebranding/contact/support.svg": 2217,
	"./images/rebranding/content/cdn.webp": 1220,
	"./images/rebranding/content/colocation.webp": 1221,
	"./images/rebranding/content/ddos.webp": 1222,
	"./images/rebranding/content/dedicated-server.webp": 1223,
	"./images/rebranding/content/dns.webp": 1224,
	"./images/rebranding/content/firewall.webp": 1225,
	"./images/rebranding/content/graphics-server.webp": 1226,
	"./images/rebranding/content/local-storage.webp": 1227,
	"./images/rebranding/content/object-storage.webp": 1228,
	"./images/rebranding/content/vpc.webp": 1229,
	"./images/rebranding/content/vps.webp": 1230,
	"./images/rebranding/content/waf.webp": 1231,
	"./images/rebranding/customerLogos/1.webp": 1369,
	"./images/rebranding/customerLogos/10.webp": 1370,
	"./images/rebranding/customerLogos/11.webp": 1371,
	"./images/rebranding/customerLogos/12.webp": 1372,
	"./images/rebranding/customerLogos/13.webp": 1373,
	"./images/rebranding/customerLogos/14.webp": 1374,
	"./images/rebranding/customerLogos/15.webp": 1375,
	"./images/rebranding/customerLogos/16.webp": 1376,
	"./images/rebranding/customerLogos/17.webp": 1377,
	"./images/rebranding/customerLogos/18.webp": 1378,
	"./images/rebranding/customerLogos/19.webp": 1379,
	"./images/rebranding/customerLogos/2.webp": 1380,
	"./images/rebranding/customerLogos/20.webp": 1381,
	"./images/rebranding/customerLogos/21.webp": 1382,
	"./images/rebranding/customerLogos/22.webp": 1383,
	"./images/rebranding/customerLogos/23.webp": 1384,
	"./images/rebranding/customerLogos/24.webp": 1385,
	"./images/rebranding/customerLogos/25.webp": 1386,
	"./images/rebranding/customerLogos/26.webp": 1387,
	"./images/rebranding/customerLogos/27.webp": 1388,
	"./images/rebranding/customerLogos/28.webp": 1389,
	"./images/rebranding/customerLogos/29.webp": 1390,
	"./images/rebranding/customerLogos/3.webp": 1391,
	"./images/rebranding/customerLogos/30.webp": 1392,
	"./images/rebranding/customerLogos/31.webp": 1393,
	"./images/rebranding/customerLogos/32.webp": 1394,
	"./images/rebranding/customerLogos/33.webp": 1395,
	"./images/rebranding/customerLogos/34.webp": 1396,
	"./images/rebranding/customerLogos/35.webp": 1397,
	"./images/rebranding/customerLogos/36.webp": 1398,
	"./images/rebranding/customerLogos/37.webp": 1399,
	"./images/rebranding/customerLogos/38.webp": 1400,
	"./images/rebranding/customerLogos/39.webp": 1401,
	"./images/rebranding/customerLogos/4.webp": 1402,
	"./images/rebranding/customerLogos/40.webp": 1403,
	"./images/rebranding/customerLogos/5.webp": 1404,
	"./images/rebranding/customerLogos/6.webp": 1405,
	"./images/rebranding/customerLogos/7.webp": 1406,
	"./images/rebranding/customerLogos/8.webp": 1407,
	"./images/rebranding/customerLogos/9.webp": 1408,
	"./images/rebranding/customers/content/e-seminar.webp": 1409,
	"./images/rebranding/customers/content/helal-ahmar.webp": 1410,
	"./images/rebranding/customers/content/ikco.webp": 1411,
	"./images/rebranding/customers/content/mapna.webp": 1412,
	"./images/rebranding/customers/content/milli-1.webp": 1413,
	"./images/rebranding/customers/content/milli.webp": 1414,
	"./images/rebranding/customers/content/solico.webp": 1415,
	"./images/rebranding/customers/e-seminar.png": 1614,
	"./images/rebranding/customers/helal-ahmar.png": 1615,
	"./images/rebranding/customers/ikco.png": 1616,
	"./images/rebranding/customers/mapna.png": 1617,
	"./images/rebranding/customers/milli-gold.png": 1618,
	"./images/rebranding/customers/solico.png": 1619,
	"./images/rebranding/heroBackground.webp": 1620,
	"./images/rebranding/logo/logo-abalon-en.png": 442,
	"./images/rebranding/logo/logo-abalon-fa.png": 403,
	"./images/rebranding/logo/logo-blue.svg": 2218,
	"./images/rebranding/logo/logo-dark.svg": 2219,
	"./images/rebranding/logo/logo-en-botton-blue.svg": 2220,
	"./images/rebranding/logo/logo-en-botton-dark.svg": 2221,
	"./images/rebranding/logo/logo-en-botton-gradiant.svg": 2222,
	"./images/rebranding/logo/logo-en-botton-white.svg": 2223,
	"./images/rebranding/logo/logo-en-left-blue.svg": 2224,
	"./images/rebranding/logo/logo-en-left-dark.svg": 2225,
	"./images/rebranding/logo/logo-en-left-gradiant.svg": 2226,
	"./images/rebranding/logo/logo-en-left-white.svg": 2227,
	"./images/rebranding/logo/logo-fa-botton-blue.svg": 2228,
	"./images/rebranding/logo/logo-fa-botton-dark.svg": 2229,
	"./images/rebranding/logo/logo-fa-botton-gradiant.svg": 2230,
	"./images/rebranding/logo/logo-fa-botton-white.svg": 2231,
	"./images/rebranding/logo/logo-fa-left-blue.svg": 2232,
	"./images/rebranding/logo/logo-fa-left-dark.svg": 2233,
	"./images/rebranding/logo/logo-fa-left-gradiant.svg": 2234,
	"./images/rebranding/logo/logo-fa-left-white.svg": 2235,
	"./images/rebranding/logo/logo-gradiant.svg": 2236,
	"./images/rebranding/logo/logo-white.svg": 2237,
	"./images/rebranding/pages/1.b820ea4 1.svg": 952,
	"./images/rebranding/pages/3.32dda95 1.svg": 953,
	"./images/rebranding/pages/Api.701b548 2.svg": 963,
	"./images/rebranding/pages/CloudCanvas.82fd9ce 1.svg": 964,
	"./images/rebranding/pages/Firewall.398439d 1.svg": 965,
	"./images/rebranding/pages/LoadBalancers.4b40924 1.svg": 966,
	"./images/rebranding/pages/Logo.svg": 961,
	"./images/rebranding/pages/NetworkTopology.3e287eb 1.svg": 967,
	"./images/rebranding/pages/Step1.73148bc.svg": 954,
	"./images/rebranding/pages/VPC-Main.b1c5b7f.svg": 870,
	"./images/rebranding/pages/VirtualMachins.217b5d7 1.svg": 968,
	"./images/rebranding/pages/Volumes.d769ca6 1.svg": 969,
	"./images/rebranding/pages/WAE.svg": 970,
	"./images/rebranding/pages/abalon-logo.svg": 971,
	"./images/rebranding/pages/cloud-platforms.png": 955,
	"./images/rebranding/pages/ddos-c.7eebc2f 1.svg": 972,
	"./images/rebranding/pages/dnsPanel.af7f507 1.svg": 956,
	"./images/rebranding/pages/domain-c.409b389.svg": 973,
	"./images/rebranding/pages/firewall-ability.1bb527e 1.svg": 974,
	"./images/rebranding/pages/firewall-ability.1bb527e 2.svg": 975,
	"./images/rebranding/pages/firewall-setting.cc1ac98 1.svg": 976,
	"./images/rebranding/pages/header.1b96d2f 1.svg": 960,
	"./images/rebranding/pages/kuber.png": 957,
	"./images/rebranding/pages/limitation.cb39432 1.svg": 977,
	"./images/rebranding/pages/list-vps.f735948 1.svg": 978,
	"./images/rebranding/pages/map.9a4bec5 1.svg": 958,
	"./images/rebranding/pages/not-found-mobile.7b6fab4.svg": 672,
	"./images/rebranding/pages/not-found.4ba4a5c 1.svg": 673,
	"./images/rebranding/pages/report-c.11b26e7 1.svg": 979,
	"./images/rebranding/pages/traffic-vps.aa00c67 1.svg": 980,
	"./images/rebranding/pages/waf-c.6f5be55 1.svg": 981,
	"./images/rebranding/pages/waf-vps.fcecd73 1.svg": 982,
	"./images/rebranding/products/card-background-1.webp": 1621,
	"./images/rebranding/products/card-background-2.webp": 1622,
	"./images/rebranding/products/card-background.webp": 1157,
	"./images/rebranding/products2/1.svg": 1623,
	"./images/rebranding/products2/2.svg": 1624,
	"./images/rebranding/products2/3.svg": 1625,
	"./images/rebranding/products2/4.svg": 1626,
	"./images/rebranding/products2/5.svg": 1627,
	"./images/rebranding/products2/6.svg": 1628,
	"./images/rebranding/products2/backup/1.svg": 1629,
	"./images/rebranding/products2/backup/2.svg": 1630,
	"./images/rebranding/products2/backup/3.svg": 1631,
	"./images/rebranding/products2/backup/4.svg": 1632,
	"./images/rebranding/products2/backup/5.svg": 1633,
	"./images/rebranding/products2/backup/6.svg": 1634,
	"./images/rebranding/products2/backup/primary.svg": 1635,
	"./images/rebranding/products2/devops/1.svg": 1636,
	"./images/rebranding/products2/devops/2.svg": 1637,
	"./images/rebranding/products2/devops/3.svg": 1638,
	"./images/rebranding/products2/devops/4.svg": 1639,
	"./images/rebranding/products2/devops/5.svg": 1640,
	"./images/rebranding/products2/devops/6.svg": 1641,
	"./images/rebranding/products2/devops/primary.svg": 1642,
	"./images/rebranding/products2/kuber/1.svg": 1643,
	"./images/rebranding/products2/kuber/2.svg": 1644,
	"./images/rebranding/products2/kuber/3.svg": 1645,
	"./images/rebranding/products2/kuber/4.svg": 1646,
	"./images/rebranding/products2/kuber/5.svg": 1647,
	"./images/rebranding/products2/kuber/6.svg": 1648,
	"./images/rebranding/products2/migration/1.svg": 1649,
	"./images/rebranding/products2/migration/2.svg": 1650,
	"./images/rebranding/products2/migration/3.svg": 1651,
	"./images/rebranding/products2/migration/4.svg": 1652,
	"./images/rebranding/products2/migration/5.svg": 1653,
	"./images/rebranding/products2/migration/6.svg": 1654,
	"./images/rebranding/products2/migration/primary.svg": 1655,
	"./images/rebranding/products2/privateCloud/1.svg": 1656,
	"./images/rebranding/products2/privateCloud/2.svg": 1657,
	"./images/rebranding/products2/privateCloud/3.svg": 1658,
	"./images/rebranding/products2/privateCloud/4.svg": 1659,
	"./images/rebranding/products2/privateCloud/5.svg": 1660,
	"./images/rebranding/products2/privateCloud/6.svg": 1661,
	"./images/rebranding/products2/privateCloud/primary.svg": 1662,
	"./images/rebranding/products2/productsPrimaryBackground.png": 1663,
	"./images/rebranding/products2/secureCloud/1.svg": 1664,
	"./images/rebranding/products2/secureCloud/2.svg": 1665,
	"./images/rebranding/products2/secureCloud/3.svg": 1666,
	"./images/rebranding/products2/secureCloud/4.svg": 1667,
	"./images/rebranding/products2/secureCloud/5.svg": 1668,
	"./images/rebranding/products2/secureCloud/6.svg": 1669,
	"./images/rebranding/products2/secureCloud/primary.svg": 1670,
	"./images/rebranding/products2/security/1.svg": 1671,
	"./images/rebranding/products2/security/2.svg": 1672,
	"./images/rebranding/products2/security/3.svg": 1673,
	"./images/rebranding/products2/security/4.svg": 1674,
	"./images/rebranding/products2/security/5.svg": 1675,
	"./images/rebranding/products2/security/6.svg": 1676,
	"./images/rebranding/products2/security/primary.svg": 1677,
	"./images/rebranding/services/services-image.webp": 1678,
	"./images/rebranding/statisticsBackground.webp": 1679,
	"./images/sectionTwo/section1.svg": 2238,
	"./images/security/1.svg": 1820,
	"./images/security/10.svg": 1821,
	"./images/security/11.svg": 1822,
	"./images/security/12.svg": 1823,
	"./images/security/13.svg": 1824,
	"./images/security/14.svg": 1825,
	"./images/security/15.svg": 1826,
	"./images/security/16.svg": 1827,
	"./images/security/17.svg": 1828,
	"./images/security/18.svg": 1829,
	"./images/security/2.svg": 1830,
	"./images/security/3.svg": 1831,
	"./images/security/4.svg": 1832,
	"./images/security/5.svg": 1833,
	"./images/security/6.svg": 1834,
	"./images/security/7.svg": 1835,
	"./images/security/8.svg": 1836,
	"./images/security/9.svg": 1837,
	"./images/security/WAF.svg": 1838,
	"./images/security/ddos-ability.svg": 1839,
	"./images/security/ddos-image.svg": 1680,
	"./images/security/ddos.svg": 1840,
	"./images/security/dlp.svg": 1841,
	"./images/security/dmz.svg": 1842,
	"./images/security/dr.svg": 1843,
	"./images/security/firewall-ability.svg": 1844,
	"./images/security/firewall-image.svg": 1537,
	"./images/security/firewall-setting.svg": 1845,
	"./images/security/firewall-web.svg": 1846,
	"./images/security/firewall.svg": 1847,
	"./images/security/header-image.svg": 1158,
	"./images/security/hunezarat.svg": 1093,
	"./images/security/iam.svg": 1848,
	"./images/security/items-1.svg": 1849,
	"./images/security/limitation.png": 1850,
	"./images/security/limitation.svg": 1851,
	"./images/security/private.svg": 1852,
	"./images/security/sandbox.svg": 1853,
	"./images/security/scan.svg": 1854,
	"./images/security/sec2-mobile.svg": 1855,
	"./images/security/sec2.svg": 1856,
	"./images/security/siem.svg": 1857,
	"./images/security/virus.svg": 1858,
	"./images/security/waf-banner.svg": 962,
	"./images/service_icons/1.jpg": 2239,
	"./images/service_icons/10.jpg": 2240,
	"./images/service_icons/11.jpg": 2241,
	"./images/service_icons/12.jpg": 2242,
	"./images/service_icons/13.jpg": 2243,
	"./images/service_icons/14.jpg": 2244,
	"./images/service_icons/15.jpg": 2245,
	"./images/service_icons/16.jpg": 2246,
	"./images/service_icons/17.jpg": 2247,
	"./images/service_icons/18.jpg": 2248,
	"./images/service_icons/19.jpg": 2249,
	"./images/service_icons/2.jpg": 2250,
	"./images/service_icons/20.jpg": 2251,
	"./images/service_icons/21.jpg": 2252,
	"./images/service_icons/22.jpg": 2253,
	"./images/service_icons/23.jpg": 2254,
	"./images/service_icons/24.jpg": 2255,
	"./images/service_icons/25.jpg": 2256,
	"./images/service_icons/26.jpg": 2257,
	"./images/service_icons/27.jpg": 2258,
	"./images/service_icons/28.jpg": 2259,
	"./images/service_icons/3.jpg": 2260,
	"./images/service_icons/4.jpg": 2261,
	"./images/service_icons/5.jpg": 2262,
	"./images/service_icons/6.jpg": 2263,
	"./images/service_icons/7.jpg": 2264,
	"./images/service_icons/8.jpg": 2265,
	"./images/service_icons/9.jpg": 2266,
	"./images/siem/Acunetix.svg": 1538,
	"./images/siem/Arista-Networks.svg": 1539,
	"./images/siem/Barracuda-NextGen.svg": 1540,
	"./images/siem/Barracuda.svg": 1541,
	"./images/siem/Bitdefender-GravityZone.svg": 1542,
	"./images/siem/Cisco-ASA.svg": 1543,
	"./images/siem/CrowdStrike-Falcon.svg": 1544,
	"./images/siem/CyberArk.svg": 1545,
	"./images/siem/F5-Network.svg": 1546,
	"./images/siem/Fortinet.svg": 1547,
	"./images/siem/Juniper-SRX.svg": 1548,
	"./images/siem/Kaspersky-Endpoint-Security.svg": 1549,
	"./images/siem/Manageengine-IPFIX.svg": 1550,
	"./images/siem/McAfee-MVISION-EDR.svg": 1551,
	"./images/siem/Metasploit.svg": 1552,
	"./images/siem/MikroTik-RouterOS.svg": 1553,
	"./images/siem/Nmap.svg": 1554,
	"./images/siem/Paessler-NetFlow.svg": 1555,
	"./images/siem/Palo-Alto-NGFW.svg": 1556,
	"./images/siem/Qualys.svg": 1557,
	"./images/siem/Rapid7-Nexpose.svg": 1558,
	"./images/siem/SonicWall-TZ.svg": 1559,
	"./images/siem/Sophos-Intercept- X.svg": 1560,
	"./images/siem/Tenable-Nessus.svg": 1561,
	"./images/siem/Trend-Micro-Apex-One.svg": 1562,
	"./images/siem/Ubiquiti-UniFi.svg": 1563,
	"./images/siem/Wireshark.svg": 1564,
	"./images/siem/palo-alto-networks.svg": 1565,
	"./images/slider.jpg": 2267,
	"./images/solutions/digital-tahavol.svg": 1859,
	"./images/solutions/organization-cloud.svg": 1860,
	"./images/solutions/organization-security.svg": 1861,
	"./images/solutions/organization-solutions.svg": 1862,
	"./images/solutions/orgranization-services.svg": 1863,
	"./images/svg/Banner.jpg": 2268,
	"./images/svg/Group409.svg": 2269,
	"./images/svg/Rectangle1.png": 2270,
	"./images/svg/Rectangle2.png": 2271,
	"./images/svg/Rectangle3.png": 2272,
	"./images/svg/Rectangle4.png": 2273,
	"./images/svg/benefit.svg": 875,
	"./images/svg/cloud.svg": 874,
	"./images/svg/not-found.png": 2274,
	"./images/svg/plan.svg": 2275,
	"./images/svg/slider-bg.svg": 1092,
	"./images/videos/vpc-video.mp4": 2276,
	"./images/videos/vps-video.mp4": 2277,
	"./images/virtualServer/Feature-1.svg": 1232,
	"./images/virtualServer/Feature-2.svg": 1233,
	"./images/virtualServer/Feature-3.svg": 1234,
	"./images/virtualServer/Feature-4.svg": 1235,
	"./images/virtualServer/Feature-5.svg": 1236,
	"./images/virtualServer/Feature-6.svg": 1237,
	"./images/virtualServer/Feature-7.svg": 1238,
	"./images/virtualServer/Feature-8.svg": 1239,
	"./images/virtualServer/Step1-m.svg": 1216,
	"./images/virtualServer/Step1.svg": 1217,
	"./images/virtualServer/Step2-m.svg": 1150,
	"./images/virtualServer/Step2.svg": 1151,
	"./images/virtualServer/Step3.svg": 1152,
	"./images/virtualServer/advancedSecurity.svg": 1240,
	"./images/virtualServer/backup.svg": 1241,
	"./images/virtualServer/easyBuy.svg": 1242,
	"./images/virtualServer/easyUse.svg": 1243,
	"./images/virtualServer/externalServer.svg": 1244,
	"./images/virtualServer/focus.svg": 1245,
	"./images/virtualServer/hosting.svg": 1246,
	"./images/virtualServer/hourlyServer.svg": 1218,
	"./images/virtualServer/iranServer.svg": 1247,
	"./images/virtualServer/liveMigration.svg": 1248,
	"./images/virtualServer/noLimit.svg": 1249,
	"./images/virtualServer/reliability.svg": 1250,
	"./images/virtualServer/siem.svg": 1251,
	"./images/virtualServer/startupLoad.svg": 1252,
	"./images/virtualServer/test.svg": 1253,
	"./images/virtualServer/virtual-server.svg": 1014,
	"./images/virtualServer/virtualDesktop.svg": 1254,
	"./images/virtualServer/virtualOrganization.svg": 1255,
	"./images/vps-icons/ManagedService-head.png": 2278,
	"./images/vps-icons/ManagedService.png": 2279,
	"./images/vps-icons/P1.png": 2280,
	"./images/vps-icons/P2.png": 2281,
	"./images/vps-icons/P3.png": 2282,
	"./images/vps-icons/P4.png": 2283,
	"./images/vps-icons/P5.png": 2284,
	"./images/vps-icons/download.png": 2285,
	"./images/vps-icons/file.png": 2286,
	"./images/vps-icons/private-cloud.png": 2287,
	"./images/vps-icons/private-icon.png": 2288,
	"./images/vps-icons/vps.png": 2289,
	"./images/vps-icons/vps_back.png": 2290,
	"./images/vps-icons/vps_icon.png": 2291,
	"./images/vps-icons/vps_icon2.png": 2292,
	"./images/vps-icons/vps_icon_fix.png": 2293,
	"./images/vps-icons/vps_icon_pic.png": 2294,
	"./images/vps-icons/vps_ip.png": 2295,
	"./images/vps-icons/vps_pattern.png": 2296,
	"./images/vps-icons/vps_pattern2.png": 2297,
	"./images/vps-icons/vps_picture.png": 2298,
	"./images/vps-icons/vps_picture2.png": 2299,
	"./images/vps-icons/vps_picture3.png": 2300,
	"./images/vps-icons/vps_security.png": 2301,
	"./images/vps-icons/vps_video.png": 2302,
	"./images/vps-icons/vpss.png": 2303,
	"./images/vps-icons/xaas-cloud.png": 2304,
	"./images/windowsVps/24.svg": 1864,
	"./images/windowsVps/Feature-1.svg": 1865,
	"./images/windowsVps/Feature-3.svg": 1866,
	"./images/windowsVps/benefit.svg": 1681,
	"./images/windowsVps/centralized.svg": 1867,
	"./images/windowsVps/chooseOs copy.svg": 1868,
	"./images/windowsVps/chooseOs.svg": 1869,
	"./images/windowsVps/configuration.svg": 1870,
	"./images/windowsVps/console.svg": 1871,
	"./images/windowsVps/dashboard.svg": 1872,
	"./images/windowsVps/ddos-d.svg": 1873,
	"./images/windowsVps/ddos.svg": 1874,
	"./images/windowsVps/dr.svg": 1875,
	"./images/windowsVps/freeSupport.svg": 1876,
	"./images/windowsVps/global.svg": 1877,
	"./images/windowsVps/hq.svg": 1878,
	"./images/windowsVps/increase.svg": 1879,
	"./images/windowsVps/infrustructure.svg": 1880,
	"./images/windowsVps/list-vps.f735948 1.svg": 1881,
	"./images/windowsVps/resource.svg": 1882,
	"./images/windowsVps/sla.svg": 1883,
	"./images/windowsVps/support.svg": 1884,
	"./images/windowsVps/traffic-vps.aa00c67 1.svg": 1885,
	"./images/windowsVps/waf-d.svg": 1886,
	"./images/windowsVps/waf-icon-active.svg": 1887,
	"./images/windowsVps/waf-icon.svg": 1888,
	"./images/windowsVps/waf-vps.fcecd73 1.svg": 1889,
	"./images/windowsVps/waf.svg": 1890,
	"./images/xaas-gift.png": 2305,
	"./images/xaas-icons/Hybrid Cloud.svg": 1891,
	"./images/xaas-icons/Private Cloud.svg": 1892,
	"./images/xaas-icons/Public Cloud.svg": 1893,
	"./images/xaas-icons/datacenter.png": 2306,
	"./images/xaas-icons/security.png": 2307,
	"./images/xaas-icons/support.png": 2308,
	"./images/xaas-icons/xaas-payment.png": 2309,
	"./images/xaas-icons/xaas-period.png": 2310,
	"./images/xaas-icons/xaas-scale.png": 2311,
	"./images/xaas-icons/xaas-security.png": 2312,
	"./images/xaas-icons/xaas-support.png": 2313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2773;